import axios from 'axios';
import { Config } from '../utils/Config';

// Create axios instance for kiosk API calls (no authentication required)
const kioskClient = axios.create({
  responseType: 'json',
  baseURL: Config.PPL_MNGMT_BASE_URL,
  transformResponse: (response) => response,
});

// Default headers and settings
kioskClient.defaults.headers.post['Content-Type'] = 'application/json';
kioskClient.defaults.headers.post.Accept = 'application/json';
kioskClient.defaults.headers.pragma = 'no-cache';
kioskClient.defaults.withCredentials = false;
kioskClient.defaults.timeout = 240000;

// In development, baseURL is staging People Management (api.s.peoplemanagement.welbee.co.uk).
// Override with REACT_APP_PPL_MNGMT_API_URL (e.g. https://localhost:56659/api) for local PM.

// Kiosk request wrapper with error handling (no auth)
const kioskRequest = (options) => {
  // No authentication token for kiosk endpoints
  return kioskClient(options)
    .then(response => {
      if (typeof response.data === 'string') {
        try {
          return JSON.parse(response.data);
        } catch {
          return response.data;
        }
      }
      return response.data;
    })
    .catch(error => {
      // Don't redirect to login for kiosk (public endpoints)
      return Promise.reject(error.response ? 
        typeof error.response.data === 'string' ? 
          JSON.parse(error.response.data) : 
          error.response.data
        : { message: error.message, success: false }
      );
    });
};

export default kioskRequest;
